<div class="dialog-wrapper">
  <div *ngIf="!isEmbededChat"></div>

  <div
    class="container-boxes scrollbar-custom-scroll-style"
    [ngClass]="{ 'flex-column': isEmbededChat }"
  >
    <div *ngIf="showVideo" class="video-modal-backdrop">
      <div
        class="video-modal-content"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
      >
        <button
          class="mb-1 w-100 d-flex justify-content-end video-close-button"
        >
          <img
            src="../../../../assets/icons/svg/close.svg"
            class="cursor-pointer"
            alt="close"
            height="20"
            width="20"
            (click)="closeVideo()"
            (keydown)="closeVideo()"
          />
        </button>
        <video id="centeredVideo" controls autoplay width="100%" height="95%">
          <source [src]="videoUrl" type="video/mp4" />
          <track kind="subtitles" />
          <track kind="descriptions" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    <div
      class="box"
      *ngFor="let box of boxes; let i = index"
      [id]="box.id"
      [ngClass]="{ 'box-embeded': isEmbededChat }"
      (click)="
        playVideo(
          'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
        )
      "
      (keydown)="
        playVideo(
          'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
        )
      "
    >
      <div class="header">
        <img [src]="box.iconPath" alt="" class="icon" />
        <h3 class="title" [ngClass]="{ 'title-embeded ': isEmbededChat }">
          {{ box.title }}
        </h3>
      </div>
      <p
        class="description scrollbar-custom-scroll-style"
        [ngClass]="{ 'description-embeded': isEmbededChat }"
      >
        {{ box.description }}
      </p>
    </div>
  </div>

  <div class="dialog-lower">
    <div class="chat-subtitle">What brings you here today?</div>
  </div>
</div>
